// Module
var code = `<div class="ellipsis-container" ng-click="\$ctrl.onClick(\$event)">
	<i class="fa-fw" ng-class="\$ctrl.checked ? 'fas fa-square-check' : 'far fa-square'"></i>
	<strong>{{\$ctrl.mediaTitle}}</strong>
</div>`;
// Exports
export default code;